export default __webpack_public_path__ + "static/media/coloring_squirrel_color.edfdf050.jpg";